import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import store from "./store/store";
import Login from "./Pages/LoginPage/login";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Error404Page from "./Pages/404page/404page";
import ProtectedRoute from "./Pages/404page/ProtectedRoute";
import LoadingScreen from "./Pages/isloadingPage/isloadingPage";
import InfoFlete from "./Pages/VistasPage/infoFlete";
import CalculoGasolina from "./Pages/VistasPage/calculoGasolina";
import CalculoGalonesTanque from "./Pages/VistasPage/calculoGalonesTanque";
import CalculoDistancia from "./Pages/VistasPage/calculoDistancia";
import PlanPago from "./Pages/Perfil/Plan/plan";
import Perfil from "./Pages/Perfil/perfil";
import Manual from "./Pages/VistasPage/manual";
import { NavBar } from "./navbar/navbar";
import ListUser from "./Filter/listUser";
import { usePaymentsQuery } from "./Pages/LoginPage/store/loginSlice";
const TransportApp = lazy(() => import("./Pages/mainpage"));
const FreightCalculator = lazy(() => import("./Pages/manolo"));

import DocumentosMain from "./Pages/documentos/ElaboracionTransito/elaboraciontransito";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00994C",
    },
    secondary: {
      main: "#999933",
    },
  },
});

function PaymentsVerifier() {
  const { isAuthenticated, token, whoami } = useSelector((state) => state.auth);

  usePaymentsQuery(
    { token, userId: whoami?.id },
    { skip: !isAuthenticated || !token || !whoami?.id }
  );

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PaymentsVerifier />
        <Router>
          <div>
            <NavBar />
            <Suspense fallback={<LoadingScreen />}>
              <Routes>
                <Route path="/" element={<LoadingScreen />} />
                <Route path="/login" element={<Login />} />
                <Route
                  path="/menu"
                  element={
                    <ProtectedRoute>
                      <TransportApp />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/documentos"
                  element={
                    <ProtectedRoute>
                      <DocumentosMain />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/freight"
                  element={
                    <ProtectedRoute>
                      <FreightCalculator />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/flete"
                  element={
                    <ProtectedRoute>
                      <InfoFlete />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/diesel"
                  element={
                    <ProtectedRoute>
                      <CalculoGasolina />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/tanque"
                  element={
                    <ProtectedRoute>
                      <CalculoGalonesTanque />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/distancia"
                  element={
                    <ProtectedRoute>
                      <CalculoDistancia />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ayuda"
                  element={
                    <ProtectedRoute>
                      <Manual />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/configuracion"
                  element={
                    <ProtectedRoute>
                    {
                      (() => {
                        const whoami = localStorage.getItem("whoami");
                        let isAdmin = false;
              
                        try {
                          if (whoami) {
                            const user = JSON.parse(whoami);
                            isAdmin = user?.role?.name === "admin";
                          }
                        } catch (err) {
                          console.error("Error al parsear whoami:", err);
                        }
              
                        return isAdmin ? <ListUser /> : <Error404Page />;
                      })()
                    }
                  </ProtectedRoute>
                  }
                />

                <Route path="*" element={<Error404Page />} />
                <Route
                  path="/perfil"
                  element={
                    <ProtectedRoute>
                      <Perfil />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/plan"
                  element={
                    <ProtectedRoute>
                      <PlanPago />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Error404Page />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
